<template>
    <button v-if="$page.props.user" type="button" class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4"
        data-bs-toggle="modal" data-bs-target="#modalBookTestDrive">
        <SteeringIcon class="me-2" />Schedule Test Drive
    </button>

    <Link :href="route('user.login')" v-else class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4">
    <SteeringIcon class="me-2" />Schedule Test Drive
    </Link>

    <div class="modal fade" id="modalBookTestDrive" tabindex="-1" role="dialog"
        aria-labelledby="modalBookTestDriveLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content px-4 py-3 rounded-4 border bg-white">
                <div class="modal-header d-flex justify-content-between border-0 pb-0">
                    <span class="modal-title fs-26 ff-dsb text-primary" id="modalBookTestDriveLabel">Schedule Test
                        Drive</span>
                    <span type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="far fa-times fs-18"></i>
                    </span>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitBooking">
                        <div class="form">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">Name <sup class="text-danger">*</sup></label>
                                        <input type="text" name="booking_name" id=""
                                            :class="{ 'is-invalid': errors.booking_name }"
                                            v-model="submitBookingForm.booking_name" class="form-control rounded-3 p-2">
                                        <div v-if="errors.booking_name" class="invalid-feedback">
                                            {{ errors.booking_name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">Email <sup class="text-danger">*</sup></label>
                                        <input type="email" name="booking_email" id=""
                                            :class="{ 'is-invalid': errors.booking_email }"
                                            v-model="submitBookingForm.booking_email"
                                            class="form-control rounded-3 p-2">
                                        <div v-if="errors.booking_email" class="invalid-feedback">
                                            {{ errors.booking_email }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group pt-md-3">
                                        <label class="form-label">Phone Number <sup class="text-danger">*</sup></label>
                                        <input type="text" name="booking_phone_number" id=""
                                            @input="submitBookingForm.booking_phone_number = $filters.validateNumberInput(submitBookingForm.booking_phone_number)"
                                            :class="{ 'is-invalid': errors.booking_phone_number }"
                                            v-model="submitBookingForm.booking_phone_number"
                                            class="form-control rounded-3 p-2">
                                        <div v-if="errors.booking_phone_number" class="invalid-feedback">
                                            {{ errors.booking_phone_number }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group pt-md-3">
                                        <label class="form-label">Select Date <sup class="text-danger">*</sup></label>
                                        <input type="date" name="booking_date" id="" class="form-control rounded-3 p-2"
                                            :class="{ 'is-invalid': errors.booking_date }"
                                            v-model="submitBookingForm.booking_date" :min="booking_dates.min_date"
                                            :max="booking_dates.max_date">
                                        <div v-if="errors.booking_date" class="invalid-feedback">
                                            {{ errors.booking_date }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group pt-md-3">
                                        <label class="form-label">Select Time <sup class="text-danger">*</sup></label>
                                        <select name="booking_slot" id="" class="form-control slot"
                                            :class="{ 'is-invalid': errors.booking_slot }"
                                            v-model="submitBookingForm.booking_slot">
                                            <option value="">Please Select Slot</option>
                                            <option :value="key" v-for="(slot, key) in booking_slots">{{ slot }}
                                            </option>
                                        </select>

                                        <div v-if="errors.booking_slot" class="invalid-feedback">
                                            {{ errors.booking_slot }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-4 hstack gap-3 justify-content-center flex-wrap">
                            <button type="button" id="closeModal"
                                class="btn-secondary rounded-3 btn py-2 fs-15 px-5 flex-sm-grow-0 flex-grow-1"
                                data-bs-dismiss="modal">Close</button>
                            <button type="submit"
                                class="btn-gradient-primary rounded-3 btn py-2 fs-15 px-5 flex-sm-grow-0 flex-grow-1"
                                :disabled="submitBookingForm.processing">
                                Confirm <i v-if="submitBookingForm.processing"
                                    class="fad fa-spinner-third fa-spin"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import SteeringIcon from '../../../../../../resources/js/front/Components/icons/SteeringIcon.vue';
import { Link } from '@inertiajs/vue3';
import axios from 'axios';
import { ref, reactive } from 'vue';
import { usePage, useForm } from '@inertiajs/vue3';

const props = defineProps({ errors: Object, booking_dates: Object, booking_slots: Object })

const page = usePage();


const submitBookingForm = useForm({
    booking_name: page.props.user ? page.props.user.name : null,
    booking_email: page.props.user ? page.props.user.email : null,
    booking_phone_number: page.props.user ? page.props.user.contact_no : null,
    booking_date: null,
    booking_slot: "",
    vehicle_id: page.props.vehicle.id,
});

const isModalOpen = ref(false);

const openModal = () => {
    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
};

const submitBooking = function () {
    submitBookingForm.post(route('front.enquiry.test-drive'), {
        preserveScroll: true,
        onSuccess: () => {
            const closeModal = document.getElementById('closeModal');
            closeModal.click();
            submitBookingForm.booking_name = page.props.user ? page.props.user.name : null;
            submitBookingForm.booking_email = page.props.user ? page.props.user.email : null;
            submitBookingForm.booking_phone_number = page.props.user ? page.props.user.contact_no : null;
            submitBookingForm.booking_date = null;
            submitBookingForm.booking_slot = "";
        }  
    });
};
</script>
